import { AlertDialogDescription } from "@/components/ui/alert-dialog";

function formatInvoiceTotal(totalFare: string | null | undefined): string {
  const parsed = parseFloat(totalFare ?? "0");
  const amount = Number.isFinite(parsed) ? parsed : 0;
  return `$${amount.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

interface VoidInvoiceConfirmDescriptionProps {
  supplierName?: string | null;
  totalFare?: string | null;
}

export function VoidInvoiceConfirmDescription({
  supplierName,
  totalFare,
}: VoidInvoiceConfirmDescriptionProps) {
  const supplier = supplierName?.trim() || "—";
  const total = formatInvoiceTotal(totalFare);

  return (
    <AlertDialogDescription className="space-y-3 text-sm leading-relaxed">
      <p>Are you sure you want to void this invoice?</p>
      <div className="text-foreground">
        <p>
          <span className="font-medium">Supplier:</span> {supplier}
        </p>
        <p>
          <span className="font-medium">Total Invoice Amount:</span> {total}
        </p>
      </div>
      <p>This action cannot be undone.</p>
    </AlertDialogDescription>
  );
}
